// import './App.css';
// import CostCalculatorPage from './Pages/CostCalculatorPage';
import Home from './Pages/HomePage';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import packageFile from '../package.json'
import Loading from './components/Loader';
import CacheBuster from 'react-cache-buster';
import ReactGA from 'react-ga'
import ThankyouPage from './Pages/ThankyouPage';

function App() {
  const { version } = packageFile
  ReactGA.initialize('AW-10999490476/ZuArCKCzqOYDEKzP-_wo');
  ReactGA.pageview(window.location.pathname + window.location.search);
  return (
    <CacheBuster
      currentVersion={version}
      isEnabled={true}
      isVerboseMode={false}
      loadingComponent={<Loading />}
      metaFileDirectory={'./'}
    >
      <BrowserRouter basename={'/top-mobile-app-development-company-india'}>
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/thankyou" exact element={<ThankyouPage />} />
          {/* <Route path="/cost-calculator" exact element={<CostCalculatorPage />} /> */}
        </Routes>
      </BrowserRouter>
    </CacheBuster>
  );
}

export default App;
